var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({attrs:{"icon":""}},_vm.$listeners),[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }